import Navbar from '../Navbar';
import Footer from '../Footer';
import Logo from "../images/a1..png";
import Topimage from '../images/Hero1.jpg';
import MechanicalCapabilities from '../MechanicalCapabilities';
import ElectricalDesign from '../ElectricalDesign';
import A1 from "../images/A5.png"
import A2 from "../images/A2.jpg"
import A3 from "../images/A3.png"
function Product() {
  return (
    <>
      <Navbar />

      {/* Hero Image with Overlay Text */}
    <div className="relative pt-4">
  <img
    src={Topimage}
    alt="Topimage"
    className="w-full max-h-[500px] object-cover object-center"
  />
  <div className="absolute inset-0 flex items-center justify-center bg-black/40">
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center">
    Automobile 
    </h2>
  </div>
</div>


      {/* Overview Section */}
      <section className="bg-gradient-to-r from-blue-50 to-blue-100 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
          {/* Text */}
          <div className="md:w-1/2 text-center md:text-left">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">Automobile Engineering Services</h1>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              At iNVORA, we offer specialized solutions in Automotive Electrical Design, System Integration,
              and Wiring Harness Engineering to accelerate product innovation and ensure compliance with global standards.
            </p>
          </div>

          {/* Image */}
          <div className="md:w-1/2 flex justify-center">
            <img
              src={Logo}
              alt="Automobile Design"
              className="w-64 sm:w-80 md:w-full max-w-md "
            />
          </div>
        </div>
      </section>

      {/* Core Services */}
      <section className="bg-white py-16 px-4 sm:px-6 lg:px-8">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-10">
      Our Core Automotive Services
    </h2>

    <div className="space-y-12">
      {/* Card 1 - Image right */}
      <div className="flex flex-col md:flex-row bg-gray-50 border rounded-xl shadow-lg overflow-hidden">
        <div className="md:w-2/3 p-6 flex flex-col justify-center">
          <h3 className="text-xl font-semibold mb-2">Wiring Harness Design</h3>
          <p className="text-sm text-gray-700">
            Development of 2D & 3D wiring harnesses using tools like MCAD and ECAD,
            optimizing for cost, routing, and maintainability.
          </p>
        </div>
        <div className="md:w-1/3">
          <img
            src={A1}
            alt="Wiring Harness"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Card 2 - Image left */}
      <div className="flex flex-col md:flex-row-reverse bg-gray-50 border rounded-xl shadow-lg overflow-hidden">
        <div className="md:w-2/3 p-6 flex flex-col justify-center">
          <h3 className="text-xl font-semibold mb-2">System & Circuit Design</h3>
          <p className="text-sm text-gray-700">
            Complete electrical system design including fuse sizing, grounding,
            connector selection, and circuit protection strategies.
          </p>
        </div>
        <div className="md:w-1/3">
          <img
            src={A3}
            alt="System Design"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Card 3 - Image right */}
      <div className="flex flex-col md:flex-row bg-gray-50 border rounded-xl shadow-lg overflow-hidden">
        <div className="md:w-2/3 p-6 flex flex-col justify-center">
          <h3 className="text-xl font-semibold mb-2">BOM & Documentation</h3>
          <p className="text-sm text-gray-700">
            Generation of Bill of Materials (BOM), manufacturing-ready documentation,
            and compliance reports tailored to OEM standards.
          </p>
        </div>
        <div className="md:w-1/3">
          <img
            src={A2}
            alt="Documentation"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  </div>
</section>
 

      <ElectricalDesign/> 

      {/* Design Capabilities */}
      <section className="bg-gray-100 text-black py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <h3 className="text-lg sm:text-xl font-semibold mb-4 border-b border-gray-700 pb-2">Design Features</h3>
            <ul className="list-disc list-inside space-y-3 text-gray-800 text-sm">
              <li>Wire harness design and electrical schematic creation</li>
              <li>Design Failure Mode and Effect Analysis (DFMEA)</li>
              <li>Bill of Materials and 3D bundle layout</li>
              <li>Waterproof connectors to prevent corrosion</li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg sm:text-xl font-semibold mb-4 border-b border-gray-700 pb-2">Design Verification</h3>
            <ul className="list-disc list-inside space-y-3 text-gray-800 text-sm">
              <li>Design to assembly and splice position planning</li>
              <li>Optimum routing lengths and branches</li>
              <li>Validation process for reliability and serviceability</li>
            </ul>
          </div>
        </div>
      </section>

      <MechanicalCapabilities />

      {/* Call to Action */}
      <section className="bg-blue-600 py-12 px-4 text-white text-center">
        <h3 className="text-xl sm:text-2xl font-bold mb-3">Looking to upgrade your automotive design process?</h3>
        <p className="mb-5 text-sm sm:text-base">Contact iNVORA today to learn how our automotive solutions can drive your innovation forward.</p>
         <a href="/#contact"
            className="inline-block bg-white text-blue-600 font-semibold px-6 py-3 rounded-md shadow hover:bg-gray-100 transition"
          >
            Get in Touch
          </a>

      </section>

      <Footer />
    </>
  );
}

export default Product;